export function LoginScreen() {
  const next = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const loginUrl = `/api/auth/line/login?next=${encodeURIComponent(next)}`;

  return (
    <div className="login">
      <h1>Admin Portal</h1>
      <p>Sign in with LINE to continue.</p>
      <a href={loginUrl} className="login-button">
        Sign in with LINE
      </a>
    </div>
  );
}
